// with this directive, when ui comes in blur state (click outside), the typed term itself is chosen
// (in commented code formerly the selected item from the option set was selected)
// adopted (and fixed) after intensive googling and trying three buggy solutions:),
// https://github.com/angular-ui/ui-select/issues/1544#issuecomment-310416471

angular.module("common.directives.uiSelectSelectOnBlur", ['ui.select']).directive('uiSelectSelectOnBlur', function ($document) {
    return {
        require: 'uiSelect',
        link(scope, elm, attrs, ctrl) {
            let body = $document[0].body,
                handleClick = (evt) => {
                    //Look for elm (the ui-select root element) somewhere in the ancestors
                    let target = evt.target;
                    if (elm === target) {
                        return;
                    }
                    while (target.parentNode) {
                        target = target.parentNode;
                        if (elm === target) {
                            return;
                        }
                    }

                    //Did not exit, therefore user clicked outside of the ui-select
                    //only select if open and something is typed
                    //Check ctrl.items also, because for ui-select with fixed data, if all possible entries
                    //  have already been selected then activeIndex will = 0 but items will be [].
                    if (ctrl.open && ctrl.search &&
                        (ctrl.items && ctrl.items.length) && (
                            ctrl.tagging.isActivated || ctrl.activeIndex >= 0)) {
                        // ctrl.select(ctrl.items[ctrl.activeIndex]);
                        ctrl.select({name: ctrl.search, text: ctrl.search});
                    }
                };

            body.addEventListener('click', handleClick);
            scope.$on('$destroy', () => {
                body.removeEventListener('click', handleClick);
            });
        }
    };
});